import { motion } from 'framer-motion';
import React, { PropsWithChildren } from 'react';

export const AnimatedOpacity = React.forwardRef(
  (
    {
      children,
      className,
      onClick
    }: PropsWithChildren<{ className?: string; onClick?: () => void }>,
    ref?: React.ForwardedRef<HTMLDivElement>
  ) => {
    return (
      <motion.div
        ref={ref}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        onClick={onClick}
        transition={{
          ease: 'linear',
          duration: 0.3,
          x: { duration: 1 }
        }}
        className={className}>
        {children}
      </motion.div>
    );
  }
);

AnimatedOpacity.displayName = 'AnimatedOpacity';
